import React, {useCallback} from 'react';
import {Layout} from '../layout';
import {Icon} from '../icons';
import {Text} from '../text';
import {Spacer} from '../spacer';
import {IconNames} from '../icons/types';

type Props = {
  index: number;
  title: string;
  icon?: string;
  selected: boolean;
  showSelected: boolean;
  onSelected: (index: number) => void;
};

export const MenuItem: React.FC<Props> = ({
  title,
  icon,
  index,
  selected,
  showSelected,
  onSelected,
}) => {
  // Handler for selected
  const handleSelected = useCallback(() => {
    onSelected(index);
  }, [onSelected, index]);

  return (
    <Layout
      hover
      horizontal
      flex={1}
      justify="space-between"
      align="center"
      backgroundColor={
        selected ? 'background_mono_tertiary' : 'background_mono_primary'
      }>
      <Layout
        horizontal
        flex
        onPress={handleSelected}
        paddingHorizontal="18"
        paddingVertical="12"
        backgroundColor={'transparent'}>
        <Layout flex horizontal>
          {icon && (
            <>
              <Icon name={icon as IconNames} />
              <Spacer width="12" />
            </>
          )}
          <Text
            align="left"
            nowrap
            textColor="content_mono_primary"
            variant={
              selected ? 'paragraph_14_emphasis' : 'paragraph_14_default'
            }>
            {title}
          </Text>
        </Layout>
        <Spacer width="8" />
        {showSelected && <Icon name="checkmarkSmall" transparent={!selected} />}
      </Layout>
    </Layout>
  );
};
